const MaxRetryAttempts = 5;
const RetryBaseDelayMs = 300; // 300ms (like the BFF RetryLink)

export { MaxRetryAttempts, RetryBaseDelayMs };
